<template>
<v-card outlined class="mb-6 rounded-lg" elevation="0" style="border: 1px solid #e0e0e0;">
  <v-card-text class="py-3 px-3 d-flex align-center flex-wrap" style="gap: 10px;">

    <!-- 1. Поиск (Flat input style) -->
    <v-text-field
      dense
      hide-details
      outlined
      v-model="search"
      placeholder="Поиск по ФИО, компании, должности..."
      prepend-inner-icon="mdi-magnify"
      style="max-width: 320px; min-width: 200px; height: 36px; margin: 0;"
      class="custom-search-field"
      @input="$emit('update:search', search)"
    ></v-text-field>

    <v-chip-group
      v-model="statusTab"
      active-class="custom-chip-active"
      mandatory
      class="ml-1 d-flex align-center  border "
      style="height: 36px; gap: 8px"
      @change="$emit('update:status', statusTab)"
    >
      <v-chip
        v-for="(tab, i) in statusTabs"
        :key="i"
        label
        small
        class="font-weight-medium px-4"
        style="height: 100%; border-radius: 4px;"
      >
        {{ tab.label }}
        <span
          class="ml-2 grey lighten-3 px-2 rounded"
          style="font-size: 11px; line-height: 16px; height: 16px; display: inline-flex; align-items: center;"
        >{{ tab.count }}</span>
      </v-chip>
    </v-chip-group>

    <!-- 3. Селект экспертов -->
    <v-select
      height="36"
      dense
      outlined
      append-icon="mdi-chevron-down"
      solo
      hide-details
      v-model="expert"
      placeholder="Все эксперты"
      :items="expertOptions"
      style="max-width: 150px; min-width: 130px; height: 36px; margin: 0 4px;"
      class="custom-select-field"
      @input="$emit('update:expert', expert)"
    ></v-select>

    <!-- 4. Селект сортировки -->
    <v-select
      solo
      append-icon="mdi-chevron-down"
      height="36"
      dense
      outlined
      hide-details
      v-model="sortBy"
      placeholder="По дате обновления"
      :items="sortOptions"
      style="max-width: 170px; min-width: 150px; height: 36px; margin: 0 4px;"
      class="custom-select-field"
      @input="$emit('update:sort', sortBy)"
    ></v-select>

    <!-- 5. Направление сортировки (возр./убыв.) для поля, выбранного в select выше -->
    <v-btn
      icon
      small
      color="grey darken-1"
      class="ml-2"
      :title="sortDir === 'desc' ? 'По убыванию' : 'По возрастанию'"
      @click="$emit('update:sortDir', sortDir === 'desc' ? 'asc' : 'desc')"
    >
      <v-icon>{{ sortDir === 'desc' ? 'mdi-sort-descending' : 'mdi-sort-ascending' }}</v-icon>
    </v-btn>

  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: 'DiagnosticsFilters',
  model: {
    prop: 'search',
    event: 'update:search'
  },
  props: {
    search: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: 0
    },
    expert: {
      type: String,
      default: 'Все эксперты'
    },
    sort: {
      type: String,
      default: 'По дате обновления'
    },
    sortDir: {
      type: String,
      default: 'desc'
    },
    counts: {
      type: Object,
      default: () => ({ all: 0, drafts: 0, final: 0 }),
    },
  },
  computed: {
    statusTabs() {
      return [
        { label: 'Все', count: this.counts.all },
        { label: 'Черновики', count: this.counts.drafts },
        { label: 'Финал', count: this.counts.final },
      ];
    },
  },
  data() {
    return {
      statusTab: this.status,
      sortBy: this.sort,
      expertOptions: ['Все эксперты'],
      sortOptions: ['По дате обновления', 'По имени', 'По статусу'],
    };
  },
  watch: {
    status(val) {
      this.statusTab = val;
    },
    sort(val) {
      this.sortBy = val;
    },
  }
};
</script>

<style lang="scss">
$primary-color: #483CB9;

.custom-search-field {
  .v-input__slot {
    background-color: #ffffff !important;
    border-radius: 4px !important;
    min-height: 36px !important;
    box-shadow: none !important;
    padding-left: 12px !important;
    & .v-input__prepend-inner{
      margin: 4px 0!important;
    }
  }

  .v-input__icon--prepend-inner .v-icon {
    color: #9e9e9e;
  }

  input::placeholder {
    color: #a0a0a0;
    font-size: 14px;
    font-weight: 400;
  }

  &.v-input--is-focused .v-input__slot {
    border-color: $primary-color !important;
    border-width: 1px !important;
  }
}

.custom-select-field {
  .v-input__slot {
    background-color: #ffffff !important;
    border: 1px solid #d0d0d0 !important;
    border-radius: 4px !important;
    min-height: 36px !important;
    box-shadow: none !important;
    & .v-input__prepend-inner{
      margin: 4px 0!important;
    }
  }

  .v-select__selection {
    font-size: 14px;
    color: #333;
  }

  .v-label {
    font-size: 14px;
    color: #a0a0a0;
  }

  .v-icon {
    color: #9e9e9e;
  }

  &.v-input--is-focused .v-input__slot {
    border-color: $primary-color !important;
  }
}

.custom-chip-active {
  background-color: rgba($primary-color, 0.08) !important;
  color: $primary-color !important;
  font-weight: 600 !important;
}
.border{
  border: 1px solid #d0d0d0 !important;
  border-radius: 4px;
}
.v-chip-group {
  & .v-chip{
    margin: 0!important;
    padding:4px 4px!important;
    &:not(.v-chip--active){
      background: transparent!important;
    }
  }
  & .v-slide-group__content{
    display: flex;
    gap: 8px;
  }

}
</style>
